
<label *ngIf='label' class='label'>
  {{ label }}
</label>
<mat-form-field class='w-full'>
  <input
    matInput
    [value]='_value'
    [placeholder]='placeholder || ""'
    (focus)="onTouched()"
    (input)="this.change($event)"
  />
</mat-form-field>
